<script>
  export default {
    props: {
      customClass: {
        type: String,
        default: 'fill-primary primary-invert',
      },
      disableHover: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<template>
  <svg
    :class="[customClass, { 'no-hover': disableHover }]"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg">
    <path stroke="none" d="M16.6019 29H7.10255C5.93782 29 5 28.068 5 26.9183V3.08168C5 1.93161 5.94658 1 7.11424 1H17.6316V7.22419C17.6316 8.37675 18.5769 9.2963 19.7431 9.2963H25V19.1462C24.1899 18.8134 23.3009 18.6296 22.3684 18.6296C18.5896 18.6296 15.5263 21.6476 15.5263 25.3704C15.5263 26.7067 15.921 27.9523 16.6019 29V29V29Z" />
    <path stroke="none" d="M13.3981 28.9999H22.8975C24.0622 28.9999 25 28.3786 25 27.6121V11.721C25 10.9543 24.0534 10.3333 22.8858 10.3333H12.3684V14.4827C12.3684 15.2511 11.4231 15.8641 10.2569 15.8641H5V22.4307C5.8101 22.2089 6.69905 22.0863 7.63158 22.0863C11.4104 22.0863 14.4737 24.0983 14.4737 26.5802C14.4737 27.4711 14.079 28.3014 13.3981 28.9999V28.9999V28.9999Z" />
    <path stroke="none" d="M18.6842 1V7.21918C18.6842 7.7936 19.1589 8.25926 19.7271 8.25926H25L18.6842 1V1Z" />
    <path
      fill="none"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.1111 17.2222C15.8293 17.2222 17.2222 15.8293 17.2222 14.1111C17.2222 12.3929 15.8293 11 14.1111 11C12.3929 11 11 12.3929 11 14.1111C11 15.8293 12.3929 17.2222 14.1111 17.2222Z"
      stroke-linecap="round"
      stroke-linejoin="round"/>
    <path
      fill="none"
      d="M19 18.9999L16.3334 16.3333"
      stroke-linecap="round"
      stroke-linejoin="round"/>
  </svg>
</template>
